<template>
  <div class="mainContent">
    <router-view :key="key" />
  </div>
</template>

<script>
export default {
  name: "appMain",
  computed: {
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContent {
  width: calc(100vw - 100px);
  height: calc(100vh - 70px);
  padding: 30px 40px;
  box-sizing: border-box;
}
</style>
